import { Header } from "./Header";
import { Footer } from "./Footer";
import { HeroSection } from "./HeroSection";

interface PublicLayoutProps {
  children: React.ReactNode;
  showHero?: boolean;
  heroTitle?: string | React.ReactNode;
  heroSubtitle?: string | React.ReactNode;
  heroVariant?: "default" | "compact";
  heroShowStatistics?: boolean;
  heroShowTrustIndicators?: boolean;
  heroChildren?: React.ReactNode;
}

export const PublicLayout = ({ 
  children, 
  showHero = false,
  heroTitle,
  heroSubtitle,
  heroVariant = "compact",
  heroShowStatistics = false,
  heroShowTrustIndicators = false,
  heroChildren
}: PublicLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {showHero && (
        <HeroSection
          title={heroTitle}
          subtitle={heroSubtitle}
          variant={heroVariant}
          showStatistics={heroShowStatistics}
          showTrustIndicators={heroShowTrustIndicators}
        >
          {heroChildren}
        </HeroSection>
      )}
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};